export const TRIP_EXPERIENCE_TYPEAHEAD_SEARCH_TYPES: Array<App.SearchType> = [
  'destination',
]

export const TRIP_PLACE_TYPEAHEAD_TYPES = [
  'city',
  'multi_city_vicinity',
  'province_state',
  'colloquial_area',
  'neighborhood',
] as Array<App.SearchPlaceType>
